import {
  Box,
  Text,
  Table,
  TableContainer,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
} from '@chakra-ui/react';
import * as _ from 'lodash';
import React from 'react';

import { date as commonDate } from '@finley-technologies/common';

import { ConcentrationLimitDataForReportingDate } from './types';
import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';
import { ToggleIcon } from 'packages/common-frontend/components/ToggleIcon';
import {
  PortfolioChartConfig,
  portfolioFormatterMap,
} from 'packages/portfolio/ui/shared/portfolioChartUtils';

const headers = ['Show', '', 'Property', 'Excess Amount'];

const ConcentrationCell = ({ label }: { label: string }) => {
  return (
    <Td fontSize="16px" color={colors.black[70]}>
      {label}
    </Td>
  );
};

// TODO: @dmads98 reconcile this component with PortfolioExcessConcentrationChartDetailsTable

type ExcessConcentrationChartDetailsTableProps = {
  selectedBarData: ConcentrationLimitDataForReportingDate;
  chartConfig: PortfolioChartConfig<any>;
  chartTitle: string;
  activeFields: (keyof ConcentrationLimitDataForReportingDate)[];
  onToggleActiveField: (
    selectedField: keyof ConcentrationLimitDataForReportingDate,
  ) => void;
};
export const ExcessConcentrationChartDetailsTable = ({
  selectedBarData,
  chartConfig,
  chartTitle,
  activeFields,
  onToggleActiveField,
}: ExcessConcentrationChartDetailsTableProps) => {
  return (
    <Box width="100%">
      <Text fontSize="16px" fontWeight={600} mb="24px">
        Reporting Date:{' '}
        {commonDate.fullDateStrToHumanDateString(selectedBarData.reportingDate)}
      </Text>

      <TableContainer width="100%">
        <Table borderWidth="1px">
          <Thead borderBottomWidth="2px">
            <Tr>
              {_.map(headers, (header) => (
                <Th
                  key={`portfolio-${chartTitle}-table-header-${header}`}
                  textTransform="none"
                  fontSize="16px"
                  fontWeight={500}
                  color={colors.black[95]}
                  letterSpacing="normal"
                  textAlign={header === 'Show' ? 'center' : undefined}
                  background={colors.background[100]}
                >
                  {header}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {_.map(chartConfig, (config, fieldName) => {
              if (!config) {
                return null;
              }
              const { label, format, color } = config;
              const formattedExcessConcentrationAmount = portfolioFormatterMap[
                format
              ](selectedBarData[fieldName]);

              const isActive = _.includes(activeFields, fieldName);
              return (
                <Tr
                  key={`portfolio-${chartTitle}-table-row-${fieldName}`}
                  background="white"
                >
                  <Td
                    cursor="pointer"
                    onClick={() => onToggleActiveField(fieldName)}
                    textAlign="center"
                  >
                    <ToggleIcon isActive={isActive} />
                  </Td>
                  <Td textAlign="center">
                    <Icon icon="square" type="solid" color={color} />
                  </Td>
                  <Td
                    fontSize="16px"
                    color={colors.black[70]}
                    wordBreak="break-word"
                    whiteSpace="normal"
                  >
                    {label}
                  </Td>
                  <ConcentrationCell
                    label={formattedExcessConcentrationAmount}
                  />
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};
